/**
 * Timezone mapping data file.
 *
 * Note: Multiple Windows timezone IDs legitimately map to the same IANA timezone identifiers.
 * This is intentional and expected - the duplication is excluded from SonarQube analysis
 * via sonar.cpd.exclusions configuration in bitbucket-pipelines.yml
 */
const timezones = [
  {
    id: 'Dateline Standard Time',
    label: '(UTC-12:00) International Date Line West',
    iana: 'Etc/GMT+12',
  },
  {
    id: 'UTC-11',
    label: '(UTC-11:00) Co-ordinated Universal Time-11',
    iana: 'Etc/GMT+11',
  },
  {
    id: 'Aleutian Standard Time',
    label: '(UTC-10:00) Aleutian Islands',
    iana: 'Etc/GMT+10',
  },
  {
    id: 'Hawaiian Standard Time',
    label: '(UTC-10:00) Hawaii',
    iana: 'Etc/GMT+10',
  },
  {
    id: 'Marquesas Standard Time',
    label: '(UTC-09:30) Marquesas Islands',
    iana: 'Pacific/Marquesas',
  },
  {
    id: 'Alaskan Standard Time',
    label: '(UTC-09:00) Alaska',
    iana: 'America/Anchorage',
  },
  {
    id: 'UTC-09',
    label: '(UTC-09:00) Co-ordinated Universal Time-09',
    iana: 'America/Anchorage',
  },
  {
    id: 'Pacific Standard Time (Mexico)',
    label: '(UTC-08:00) Baja California',
    iana: 'America/Santa_Isabel',
  },
  {
    id: 'UTC-08',
    label: '(UTC-08:00) Co-ordinated Universal Time-08',
    iana: 'America/Santa_Isabel',
  },
  {
    id: 'Pacific Standard Time',
    label: '(UTC-08:00) Pacific Time (US & Canada)',
    iana: 'America/Santa_Isabel',
  },
  {
    id: 'US Mountain Standard Time',
    label: '(UTC-07:00) Arizona',
    iana: 'America/Dawson',
  },
  {
    id: 'Mountain Standard Time (Mexico)',
    label: '(UTC-07:00) Chihuahua, La Paz, Mazatlan',
    iana: 'America/Dawson',
  },
  {
    id: 'Mountain Standard Time',
    label: '(UTC-07:00) Mountain Time (US & Canada)',
    iana: 'America/Dawson',
  },
  {
    id: 'Central America Standard Time',
    label: '(UTC-06:00) Central America',
    iana: 'America/Belize',
  },
  {
    id: 'Central Standard Time',
    label: '(UTC-06:00) Central Time (US & Canada)',
    iana: 'America/Belize',
  },
  {
    id: 'Easter Island Standard Time',
    label: '(UTC-06:00) Easter Island',
    iana: 'America/Belize',
  },
  {
    id: 'Central Standard Time (Mexico)',
    label: '(UTC-06:00) Guadalajara, Mexico City, Monterrey',
    iana: 'America/Belize',
  },
  {
    id: 'Canada Central Standard Time',
    label: '(UTC-06:00) Saskatchewan',
    iana: 'America/Belize',
  },
  {
    id: 'SA Pacific Standard Time',
    label: '(UTC-05:00) Bogota, Lima, Quito, Rio Branco',
    iana: 'America/Bogota',
  },
  {
    id: 'Eastern Standard Time (Mexico)',
    label: '(UTC-05:00) Chetumal',
    iana: 'America/Bogota',
  },
  {
    id: 'Eastern Standard Time',
    label: '(UTC-05:00) Eastern Time (US & Canada)',
    iana: 'America/Bogota',
  },
  {
    id: 'Haiti Standard Time',
    label: '(UTC-05:00) Haiti',
    iana: 'America/Bogota',
  },
  {
    id: 'Cuba Standard Time',
    label: '(UTC-05:00) Havana',
    iana: 'America/Bogota',
  },
  {
    id: 'US Eastern Standard Time',
    label: '(UTC-05:00) Indiana (East)',
    iana: 'America/Bogota',
  },
  {
    id: 'Turks And Caicos Standard Time',
    label: '(UTC-05:00) Turks and Caicos',
    iana: 'America/Bogota',
  },
  {
    id: 'Paraguay Standard Time',
    label: '(UTC-04:00) Asuncion',
    iana: 'America/Asuncion',
  },
  {
    id: 'Atlantic Standard Time',
    label: '(UTC-04:00) Atlantic Time (Canada)',
    iana: 'America/Asuncion',
  },
  {
    id: 'Venezuela Standard Time',
    label: '(UTC-04:00) Caracas',
    iana: 'America/Asuncion',
  },
  {
    id: 'Central Brazilian Standard Time',
    label: '(UTC-04:00) Cuiaba',
    iana: 'America/Asuncion',
  },
  {
    id: 'SA Western Standard Time',
    label: '(UTC-04:00) Georgetown, La Paz, Manaus, San Juan',
    iana: 'America/Asuncion',
  },
  {
    id: 'Pacific SA Standard Time',
    label: '(UTC-04:00) Santiago',
    iana: 'America/Asuncion',
  },
  {
    id: 'Newfoundland Standard Time',
    label: '(UTC-03:30) Newfoundland',
    iana: 'America/St_Johns',
  },
  {
    id: 'Tocantins Standard Time',
    label: '(UTC-03:00) Araguaina',
    iana: 'America/Sao_Paulo',
  },
  {
    id: 'E. South America Standard Time',
    label: '(UTC-03:00) Brasilia',
    iana: 'America/Sao_Paulo',
  },
  {
    id: 'SA Eastern Standard Time',
    label: '(UTC-03:00) Cayenne, Fortaleza',
    iana: 'America/Sao_Paulo',
  },
  {
    id: 'Argentina Standard Time',
    label: '(UTC-03:00) City of Buenos Aires',
    iana: 'America/Sao_Paulo',
  },
  {
    id: 'Greenland Standard Time',
    label: '(UTC-03:00) Greenland',
    iana: 'America/Sao_Paulo',
  },
  {
    id: 'Montevideo Standard Time',
    label: '(UTC-03:00) Montevideo',
    iana: 'America/Sao_Paulo',
  },
  {
    id: 'Magallanes Standard Time',
    label: '(UTC-03:00) Punta Arenas',
    iana: 'America/Sao_Paulo',
  },
  {
    id: 'Saint Pierre Standard Time',
    label: '(UTC-03:00) Saint Pierre and Miquelon',
    iana: 'America/Sao_Paulo',
  },
  {
    id: 'Bahia Standard Time',
    label: '(UTC-03:00) Salvador',
    iana: 'America/Sao_Paulo',
  },
  {
    id: 'UTC-02',
    label: '(UTC-02:00) Co-ordinated Universal Time-02',
    iana: 'America/Noronha',
  },
  {
    id: 'Mid-Atlantic Standard Time',
    label: '(UTC-02:00) Mid-Atlantic - Old',
    iana: 'America/Noronha',
  },
  {
    id: 'Azores Standard Time',
    label: '(UTC-01:00) Azores',
    iana: 'America/Scoresbysund',
  },
  {
    id: 'Cape Verde Standard Time',
    label: '(UTC-01:00) Cabo Verde Is.',
    iana: 'America/Scoresbysund',
  },
  {
    id: 'UTC',
    label: '(UTC) Co-ordinated Universal Time',
    iana: 'Etc/UTC',
  },
  {
    id: 'GMT Standard Time',
    label: '(UTC+00:00) Dublin, Edinburgh, Lisbon, London',
    iana: 'Etc/GMT',
  },
  {
    id: 'Greenwich Standard Time',
    label: '(UTC+00:00) Monrovia, Reykjavik',
    iana: 'Etc/GMT',
  },
  {
    id: 'W. Europe Standard Time',
    label: '(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna',
    iana: 'Europe/Isle_of_Man',
  },
  {
    id: 'Central Europe Standard Time',
    label: '(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague',
    iana: 'Europe/Isle_of_Man',
  },
  {
    id: 'Romance Standard Time',
    label: '(UTC+01:00) Brussels, Copenhagen, Madrid, Paris',
    iana: 'Europe/Isle_of_Man',
  },
  {
    id: 'Morocco Standard Time',
    label: '(UTC+01:00) Casablanca',
    iana: 'Europe/Isle_of_Man',
  },
  {
    id: 'Sao Tome Standard Time',
    label: '(UTC+01:00) Sao Tome',
    iana: 'Europe/Isle_of_Man',
  },
  {
    id: 'Central European Standard Time',
    label: '(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb',
    iana: 'Europe/Isle_of_Man',
  },
  {
    id: 'W. Central Africa Standard Time',
    label: '(UTC+01:00) West Central Africa',
    iana: 'Europe/Isle_of_Man',
  },
  {
    id: 'Jordan Standard Time',
    label: '(UTC+02:00) Amman',
    iana: 'Asia/Nicosia',
  },
  {
    id: 'GTB Standard Time',
    label: '(UTC+02:00) Athens, Bucharest',
    iana: 'Asia/Nicosia',
  },
  {
    id: 'Middle East Standard Time',
    label: '(UTC+02:00) Beirut',
    iana: 'Asia/Nicosia',
  },
  {
    id: 'Egypt Standard Time',
    label: '(UTC+02:00) Cairo',
    iana: 'Asia/Nicosia',
  },
  {
    id: 'E. Europe Standard Time',
    label: '(UTC+02:00) Chisinau',
    iana: 'Asia/Nicosia',
  },
  {
    id: 'Syria Standard Time',
    label: '(UTC+02:00) Damascus',
    iana: 'Asia/Nicosia',
  },
  {
    id: 'West Bank Standard Time',
    label: '(UTC+02:00) Gaza, Hebron',
    iana: 'Asia/Nicosia',
  },
  {
    id: 'South Africa Standard Time',
    label: '(UTC+02:00) Harare, Pretoria',
    iana: 'Asia/Nicosia',
  },
  {
    id: 'FLE Standard Time',
    label: '(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius',
    iana: 'Asia/Nicosia',
  },
  {
    id: 'Israel Standard Time',
    label: '(UTC+02:00) Jerusalem',
    iana: 'Asia/Nicosia',
  },
  {
    id: 'Kaliningrad Standard Time',
    label: '(UTC+02:00) Kaliningrad',
    iana: 'Asia/Nicosia',
  },
  {
    id: 'Sudan Standard Time',
    label: '(UTC+02:00) Khartoum',
    iana: 'Asia/Nicosia',
  },
  {
    id: 'Libya Standard Time',
    label: '(UTC+02:00) Tripoli',
    iana: 'Asia/Nicosia',
  },
  {
    id: 'Namibia Standard Time',
    label: '(UTC+02:00) Windhoek',
    iana: 'Asia/Nicosia',
  },
  {
    id: 'Arabic Standard Time',
    label: '(UTC+03:00) Baghdad',
    iana: 'Europe/Istanbul',
  },
  {
    id: 'Turkey Standard Time',
    label: '(UTC+03:00) Istanbul',
    iana: 'Europe/Istanbul',
  },
  {
    id: 'Arab Standard Time',
    label: '(UTC+03:00) Kuwait, Riyadh',
    iana: 'Europe/Istanbul',
  },
  {
    id: 'Belarus Standard Time',
    label: '(UTC+03:00) Minsk',
    iana: 'Europe/Istanbul',
  },
  {
    id: 'Russian Standard Time',
    label: '(UTC+03:00) Moscow, St Petersburg',
    iana: 'Europe/Istanbul',
  },
  {
    id: 'E. Africa Standard Time',
    label: '(UTC+03:00) Nairobi',
    iana: 'Europe/Istanbul',
  },
  {
    id: 'Iran Standard Time',
    label: '(UTC+03:30) Tehran',
    iana: 'Asia/Tehran',
  },
  {
    id: 'Arabian Standard Time',
    label: '(UTC+04:00) Abu Dhabi, Muscat',
    iana: 'Europe/Astrakhan',
  },
  {
    id: 'Astrakhan Standard Time',
    label: '(UTC+04:00) Astrakhan, Ulyanovsk',
    iana: 'Europe/Astrakhan',
  },
  {
    id: 'Azerbaijan Standard Time',
    label: '(UTC+04:00) Baku',
    iana: 'Europe/Astrakhan',
  },
  {
    id: 'Russia Time Zone 3',
    label: '(UTC+04:00) Izhevsk, Samara',
    iana: 'Europe/Astrakhan',
  },
  {
    id: 'Mauritius Standard Time',
    label: '(UTC+04:00) Port Louis',
    iana: 'Europe/Astrakhan',
  },
  {
    id: 'Saratov Standard Time',
    label: '(UTC+04:00) Saratov',
    iana: 'Europe/Astrakhan',
  },
  {
    id: 'Georgian Standard Time',
    label: '(UTC+04:00) Tbilisi',
    iana: 'Europe/Astrakhan',
  },
  {
    id: 'Volgograd Standard Time',
    label: '(UTC+04:00) Volgograd',
    iana: 'Europe/Astrakhan',
  },
  {
    id: 'Caucasus Standard Time',
    label: '(UTC+04:00) Yerevan',
    iana: 'Europe/Astrakhan',
  },
  {
    id: 'Afghanistan Standard Time',
    label: '(UTC+04:30) Kabul',
    iana: 'Asia/Kabul',
  },
  {
    id: 'West Asia Standard Time',
    label: '(UTC+05:00) Ashgabat, Tashkent',
    iana: 'Antarctica/Mawson',
  },
  {
    id: 'Ekaterinburg Standard Time',
    label: '(UTC+05:00) Ekaterinburg',
    iana: 'Antarctica/Mawson',
  },
  {
    id: 'Pakistan Standard Time',
    label: '(UTC+05:00) Islamabad, Karachi',
    iana: 'Antarctica/Mawson',
  },
  {
    id: 'India Standard Time',
    label: '(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi',
    iana: 'Asia/Kolkata',
  },
  {
    id: 'Sri Lanka Standard Time',
    label: '(UTC+05:30) Sri Jayawardenepura',
    iana: 'Asia/Kolkata',
  },
  {
    id: 'Nepal Standard Time',
    label: '(UTC+05:45) Kathmandu',
    iana: 'Asia/Kathmandu',
  },
  {
    id: 'Central Asia Standard Time',
    label: '(UTC+06:00) Astana',
    iana: 'Antarctica/Vostok',
  },
  {
    id: 'Bangladesh Standard Time',
    label: '(UTC+06:00) Dhaka',
    iana: 'Antarctica/Vostok',
  },
  {
    id: 'Omsk Standard Time',
    label: '(UTC+06:00) Omsk',
    iana: 'Antarctica/Vostok',
  },
  {
    id: 'Myanmar Standard Time',
    label: '(UTC+06:30) Yangon (Rangoon)',
    iana: 'Asia/Rangoon',
  },
  {
    id: 'SE Asia Standard Time',
    label: '(UTC+07:00) Bangkok, Hanoi, Jakarta',
    iana: 'Antarctica/Davis',
  },
  {
    id: 'Altai Standard Time',
    label: '(UTC+07:00) Barnaul, Gorno-Altaysk',
    iana: 'Antarctica/Davis',
  },
  {
    id: 'W. Mongolia Standard Time',
    label: '(UTC+07:00) Hovd',
    iana: 'Antarctica/Davis',
  },
  {
    id: 'North Asia Standard Time',
    label: '(UTC+07:00) Krasnoyarsk',
    iana: 'Antarctica/Davis',
  },
  {
    id: 'N. Central Asia Standard Time',
    label: '(UTC+07:00) Novosibirsk',
    iana: 'Antarctica/Davis',
  },
  {
    id: 'Tomsk Standard Time',
    label: '(UTC+07:00) Tomsk',
    iana: 'Antarctica/Davis',
  },
  {
    id: 'China Standard Time',
    label: '(UTC+08:00) Beijing, Chongqing, Hong Kong SAR, Urumqi',
    iana: 'Asia/Hong_Kong',
  },
  {
    id: 'North Asia East Standard Time',
    label: '(UTC+08:00) Irkutsk',
    iana: 'Asia/Hong_Kong',
  },
  {
    id: 'Singapore Standard Time',
    label: '(UTC+08:00) Kuala Lumpur, Singapore',
    iana: 'Asia/Hong_Kong',
  },
  {
    id: 'W. Australia Standard Time',
    label: '(UTC+08:00) Perth',
    iana: 'Asia/Hong_Kong',
  },
  {
    id: 'Taipei Standard Time',
    label: '(UTC+08:00) Taipei',
    iana: 'Asia/Hong_Kong',
  },
  {
    id: 'Ulaanbaatar Standard Time',
    label: '(UTC+08:00) Ulaanbaatar',
    iana: 'Asia/Hong_Kong',
  },
  {
    id: 'Aus Central W. Standard Time',
    label: '(UTC+08:45) Eucla',
    iana: 'Australia/Eucla',
  },
  {
    id: 'Transbaikal Standard Time',
    label: '(UTC+09:00) Chita',
    iana: 'Asia/Dili',
  },
  {
    id: 'Tokyo Standard Time',
    label: '(UTC+09:00) Osaka, Sapporo, Tokyo',
    iana: 'Asia/Dili',
  },
  {
    id: 'North Korea Standard Time',
    label: '(UTC+09:00) Pyongyang',
    iana: 'Asia/Dili',
  },
  {
    id: 'Korea Standard Time',
    label: '(UTC+09:00) Seoul',
    iana: 'Asia/Dili',
  },
  {
    id: 'Yakutsk Standard Time',
    label: '(UTC+09:00) Yakutsk',
    iana: 'Asia/Dili',
  },
  {
    id: 'Cen. Australia Standard Time',
    label: '(UTC+09:30) Adelaide',
    iana: 'Australia/Adelaide',
  },
  {
    id: 'AUS Central Standard Time',
    label: '(UTC+09:30) Darwin',
    iana: 'Australia/Adelaide',
  },
  {
    id: 'E. Australia Standard Time',
    label: '(UTC+10:00) Brisbane',
    iana: 'Australia/Brisbane',
  },
  {
    id: 'AUS Eastern Standard Time',
    label: '(UTC+10:00) Canberra, Melbourne, Sydney',
    iana: 'Australia/Brisbane',
  },
  {
    id: 'West Pacific Standard Time',
    label: '(UTC+10:00) Guam, Port Moresby',
    iana: 'Australia/Brisbane',
  },
  {
    id: 'Tasmania Standard Time',
    label: '(UTC+10:00) Hobart',
    iana: 'Australia/Brisbane',
  },
  {
    id: 'Vladivostok Standard Time',
    label: '(UTC+10:00) Vladivostok',
    iana: 'Australia/Brisbane',
  },
  {
    id: 'Lord Howe Standard Time',
    label: '(UTC+10:30) Lord Howe Island',
    iana: 'Australia/Lord_Howe',
  },
  {
    id: 'Bougainville Standard Time',
    label: '(UTC+11:00) Bougainville Island',
    iana: 'Antarctica/Macquarie',
  },
  {
    id: 'Russia Time Zone 10',
    label: '(UTC+11:00) Chokurdakh',
    iana: 'Antarctica/Macquarie',
  },
  {
    id: 'Magadan Standard Time',
    label: '(UTC+11:00) Magadan',
    iana: 'Antarctica/Macquarie',
  },
  {
    id: 'Norfolk Standard Time',
    label: '(UTC+11:00) Norfolk Island',
    iana: 'Antarctica/Macquarie',
  },
  {
    id: 'Sakhalin Standard Time',
    label: '(UTC+11:00) Sakhalin',
    iana: 'Antarctica/Macquarie',
  },
  {
    id: 'Central Pacific Standard Time',
    label: '(UTC+11:00) Solomon Is., New Caledonia',
    iana: 'Antarctica/Macquarie',
  },
  {
    id: 'Russia Time Zone 11',
    label: '(UTC+12:00) Anadyr, Petropavlovsk-Kamchatsky',
    iana: 'Antarctica/McMurdo',
  },
  {
    id: 'New Zealand Standard Time',
    label: '(UTC+12:00) Auckland, Wellington',
    iana: 'Antarctica/McMurdo',
  },
  {
    id: 'UTC+12',
    label: '(UTC+12:00) Co-ordinated Universal Time+12',
    iana: 'Antarctica/McMurdo',
  },
  {
    id: 'Fiji Standard Time',
    label: '(UTC+12:00) Fiji',
    iana: 'Antarctica/McMurdo',
  },
  {
    id: 'Kamchatka Standard Time',
    label: '(UTC+12:00) Petropavlovsk-Kamchatsky - Old',
    iana: 'Antarctica/McMurdo',
  },
  {
    id: 'Chatham Islands Standard Time',
    label: '(UTC+12:45) Chatham Islands',
    iana: 'Pacific/Chatham',
  },
  {
    id: 'UTC+13',
    label: '(UTC+13:00) Co-ordinated Universal Time+13',
    iana: 'Etc/GMT-13',
  },
  {
    id: 'Tonga Standard Time',
    label: "(UTC+13:00) Nuku'alofa",
    iana: 'Etc/GMT-13',
  },
  {
    id: 'Samoa Standard Time',
    label: '(UTC+13:00) Samoa',
    iana: 'Etc/GMT-13',
  },
  {
    id: 'Line Islands Standard Time',
    label: '(UTC+14:00) Kiritimati Island',
    iana: 'Pacific/Kiritimati',
  },
];

export default timezones;
